// extracted by mini-css-extract-plugin
export default {"nav_link_bottom":"BottomLinks_nav_link_bottom__itgtZ","selected":"BottomLinks_selected__ls8jo"};